'use client';

import Script from 'next/script';
import { useEffect, useState } from 'react';

import { isLiveMarketingHost } from '@/lib/tracking/marketing-tags';

import { ADSENSE_CLIENT_ID } from './placements';
import { useAdSettings } from './use-ad-settings';

/**
 * Loads adsbygoogle.js once when the host is live and ads_enabled is yes.
 * Mount near the root (account + marketing shells).
 */
export function AdSenseScript() {
  const { flags, loaded } = useAdSettings();
  const [hostname, setHostname] = useState('');

  useEffect(() => {
    setHostname(window.location.hostname);
  }, []);

  if (!loaded || !hostname) {
    return null;
  }
  if (flags.ads_enabled !== 'yes') {
    return null;
  }
  if (!isLiveMarketingHost(hostname)) {
    return null;
  }

  return (
    <Script
      id="kw-adsense"
      src={`https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${ADSENSE_CLIENT_ID}`}
      strategy="lazyOnload"
      crossOrigin="anonymous"
    />
  );
}
